import { ReactNodeViewRenderer } from '@tiptap/react';
import { FC } from 'react';
import { PdfComponentExt } from '@distribute/shared/tiptap/extensions';
import { PdfComponentView } from './PdfComponent.renderer';
import { environment } from '../../../../environments/environment';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pdfComponent: {
      setPdfComponent: ({
        fileUrl,
        fileName,
        position,
      }: {
        fileUrl: string;
        fileName: string;
        position?: number;
      }) => ReturnType;
    };
  }
}

export const PdfComponentExtension = PdfComponentExt.extend({
  addCommands() {
    return {
      setPdfComponent:
        ({ fileUrl, fileName, position }) =>
        ({ commands, editor }) => {
          if (position) {
            return commands.insertContentAt(position, {
              type: this.name,
              attrs: {
                fileUrl,
                fileName,
                origin: environment.appOrigin,
                'data-media-width': editor.view.dom.offsetWidth - 40, // 40 - paddingsValue
                'data-media-height': 600,
                'data-align': 'center',
              },
            });
          }
          return commands.insertContent({
            type: this.name,
            attrs: {
              fileUrl,
              fileName,
              origin: environment.appOrigin,
              'data-media-width': editor.view.dom.offsetWidth - 40, // 40 - paddingsValue
              'data-media-height': 600,
              'data-align': 'center',
            },
          });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(PdfComponentView as FC);
  },
});
